import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('mesCalRsltStore', Object.keys(getters)),
	...mapState('mesCalRsltStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('mesCalRsltStore', Object.keys(actions)),
	...mapMutations('mesCalRsltStore', Object.keys(mutations))
};
